<template>
  <highlight-card
    :button="{ label: familyUrl ? texts.flowersToCeremony : texts.buyFlowers }"
    :buttons-label="texts.flowersOrderWithDelivery"
    :fact="{ icon: 'customFlower', text: fact }"
    :heading="texts.orderFlowers"
    :image="image ? { ...image, cover: true } : null"
    :secondary-button="
      familyUrl
        ? { external: true, href: familyUrl, label: texts.flowersToFamily }
        : undefined
    "
    :status="status"
    :text="familyUrl ? texts.flowersCardText : texts.showYourConsideration"
    @action="order"
  />
</template>

<script lang="ts" setup>
  import { sprintf } from "sprintf-js";
  import { computed } from "vue";
  import { EventBus } from "../../../event-bus";
  import type { CardPhoto } from "../../../highlights/cards";
  import { flowersTimeLeft } from "../../../highlights/countdown";
  import { highlightTexts } from "../../../highlights/texts";
  import HighlightCard from "../HighlightCard.vue";

  /**
   * Flowers to the ceremony from our shop, while it still takes orders. With a
   * `familyUrl` the card also offers home delivery to the family via the partner.
   */
  const props = defineProps<{
    deadline: string;
    familyUrl?: string;
    image?: CardPhoto;
    now: Date;
  }>();

  const texts = highlightTexts();
  const timeLeft = computed(() =>
    flowersTimeLeft(props.deadline, props.now, {
      flowersDaysLeft: texts.flowersDaysLeft,
      flowersHoursLeft: texts.flowersHoursLeft,
      flowersOneHourLeft: texts.flowersOneHourLeft,
    })
  );
  const fact = computed(() =>
    timeLeft.value
      ? sprintf(texts.timeLeft, timeLeft.value)
      : texts.orderFlowers
  );
  const status = computed(() =>
    timeLeft.value
      ? `${props.familyUrl ? texts.flowersLastOrderToCeremonyIn : texts.flowersLastOrderIn} ${timeLeft.value}`
      : ""
  );

  function order() {
    EventBus.emit("navigate-to", texts.flowerNavLabel);
  }
</script>
